{
  "shared": {
    "form": {
      "notSaved": "لم يُحفظ",
      "saved": "تم حفظ التغييرات.",
      "discard": {
        "title": "تجاهل التغييرات غير المحفوظة؟",
        "body": "ما كتبته في هذا النموذج لم يُحفظ بعد. إذا غادرت الآن فسيضيع.",
        "keep": "متابعة التعديل",
        "discard": "تجاهل التغييرات"
      },
      "money": {
        "required": "أدخل المبلغ.",
        "format": "أدخل المبلغ بالأرقام، مثل 1250.50: أرقام ونقطة عشرية واحدة، بلا فواصل.",
        "negative": "لا يمكن أن يكون المبلغ سالباً.",
        "decimals": "استخدم {{places}} منازل عشرية على الأكثر."
      },
      "supplier": {
        "newTitle": "إضافة مورد",
        "newSubtitle": "يبدأ المورّد الجديد مسودةً، ولا يُشترى منه إلا بعد تفعيله واعتماد تأهيله.",
        "editTitle": "تعديل {{name}}",
        "editSubtitle": "تحتفظ أوامر الشراء الصادرة ببيانات المورّد كما كانت عند إصدارها.",
        "submitNew": "إضافة المورّد",
        "submitEdit": "حفظ التغييرات",
        "summaryNew": "لم تتم إضافة المورّد",
        "summaryEdit": "لم تُحفظ التغييرات",
        "added": "أُضيف المورّد {{code}} مسودةً.",
        "addedNext": "الخطوة التالية: فعّله ثم أكمل تأهيله قبل أن يطلب منه أحد.",
        "saved": "حُفظ المورّد {{code}}.",
        "openRecord": "فتح سجل المورّد",
        "addAnother": "إضافة مورد آخر",
        "backToList": "العودة إلى الموردين",
        "notAvailableTitle": "غير متاح لك",
        "notAvailableBody": "إضافة الموردين وتعديلهم ليست من صلاحيات دورك. اطلبها من المسؤول إن احتجت إليها.",
        "sections": {
          "identity": "الهوية",
          "identityHint": "كيف يُعرف هذا المورّد في منشأتك وفي سجله الرسمي.",
          "legal": "البيانات النظامية والضريبية",
          "legalHint": "تُطابق صيغتها ما تصدره الجهات الرسمية، وكل رقم فريد بين مورّديك.",
          "contact": "جهة التواصل الرئيسية",
          "contactHint": "بيانات التواصل العامة للمورّد.",
          "commercial": "الشروط التجارية",
          "commercialHint": "للاطلاع فقط. كل اتفاقية وأمر شراء يحدد عملته وشروطه."
        },
        "code": {
          "placeholder": "RET-SUP-001",
          "hint": "رمز داخلي يُعرّف هذا المورّد. حروف لاتينية وأرقام و- و_ فقط، ولا يتكرر في منشأتك."
        },
        "nameEn": {
          "label": "الاسم بالإنجليزية",
          "placeholder": "Example Catering Supplies"
        },
        "nameAr": {
          "label": "الاسم بالعربية",
          "placeholder": "مؤسسة مثال للتموين"
        },
        "nameHint": "الاسم الذي يعرف به فريقك هذا المورّد.",
        "legalNameEn": {
          "label": "الاسم النظامي بالإنجليزية",
          "placeholder": "Example Catering Supplies Co. Ltd."
        },
        "legalNameAr": {
          "label": "الاسم النظامي بالعربية",
          "placeholder": "شركة مثال للتموين المحدودة"
        },
        "legalNameHint": "كما هو مكتوب في السجل التجاري. اتركه فارغاً إذا كان مطابقاً للاسم.",
        "cr": {
          "placeholder": "1010123456",
          "hint": "10 أرقام."
        },
        "vat": {
          "placeholder": "310123456700003",
          "hint": "15 رقماً، أوله وآخره الرقم 3."
        },
        "email": {
          "label": "البريد الإلكتروني",
          "placeholder": "purchasing@supplier.example",
          "hint": "عنوان المشتريات العام لدى المورّد."
        },
        "phone": {
          "label": "الهاتف",
          "placeholder": "+966 5X XXX XXXX",
          "hint": "اكتب رمز الدولة."
        },
        "website": {
          "placeholder": "https://www.supplier.example",
          "hint": "العنوان الكامل، ويبدأ بـ https://."
        },
        "currency": {
          "hint": "للاطلاع فقط، ولا يُحوَّل بها أي مبلغ.",
          "none": "غير محددة",
          "inactive": "{{code}} (لم تعد مفعّلة)"
        },
        "paymentTerms": {
          "placeholder": "30 يوماً من تاريخ الفاتورة",
          "hint": "كما اتُّفق عليه مع المورّد، في كلمات قليلة."
        },
        "leadTime": {
          "label": "مدة التوريد المعتادة",
          "unit": "أيام",
          "placeholder": "7",
          "hint": "عدد الأيام من الطلب حتى التسليم، من 0 إلى 365."
        },
        "problems": {
          "codeRequired": "أدخل رمز المورّد.",
          "codeFormat": "استخدم حروفاً لاتينية وأرقاماً و- و_ فقط، بحد أقصى 40 حرفاً.",
          "nameEnRequired": "أدخل الاسم بالإنجليزية.",
          "nameArRequired": "أدخل الاسم بالعربية.",
          "crFormat": "السجل التجاري 10 أرقام بالضبط.",
          "vatFormat": "الرقم الضريبي 15 رقماً، أوله وآخره الرقم 3.",
          "emailFormat": "أدخل بريداً إلكترونياً مثل purchasing@supplier.example.",
          "websiteFormat": "أدخل العنوان الكامل، ويبدأ بـ https://.",
          "leadTimeFormat": "أدخل عدد أيام صحيحاً من 0 إلى 365."
        },
        "archivedTitle": "هذا المورّد مؤرشف",
        "archivedBody": "يُحفظ سجل المورّد المؤرشف كما كان، ولا يمكن تعديله."
      },
      "requiredNote": "الحقول المعلَّمة بـ * مطلوبة.",
      "user": {
        "editTitle": "تعديل {{name}}",
        "summary": "لم يُحفظ المستخدم",
        "added": "أُضيف {{name}}.",
        "saved": "حُفظ {{name}}.",
        "sections": {
          "person": "الشخص",
          "personHint": "صاحب هذا الحساب. يسجّل الدخول ببريده الإلكتروني.",
          "access": "الوصول",
          "accessHint": "ما يحق له فعله. كل دور مجموعة صلاحيات تحددها منشأتك.",
          "scope": "نطاق العمل",
          "scopeHint": "سجلات من يطّلع عليها ويعمل عليها."
        },
        "name": {
          "placeholder": "Sara Example"
        },
        "nameAr": {
          "placeholder": "سارة المثال"
        },
        "email": {
          "placeholder": "name@organisation.example",
          "hint": "عنوان تسجيل دخوله، ولا يتكرر في منشأتك."
        },
        "jobTitle": {
          "placeholder": "مسؤول مشتريات"
        },
        "scope": {
          "hint": "المنشأة بالكامل، أو وحدات شراء مختارة، أو لا شيء بعد.",
          "none": "لا شيء بعد"
        },
        "nodes": {
          "label": "وحدات الشراء",
          "hint": "ابحث بالاسم أو الرمز. يطّلع على سجلات وحدات الشراء هذه ويعمل عليها فقط.",
          "placeholder": "أضف وحدة شراء"
        },
        "problems": {
          "nameRequired": "أدخل اسمه.",
          "emailRequired": "أدخل بريده الإلكتروني.",
          "emailFormat": "أدخل بريداً إلكترونياً مثل name@organisation.example."
        }
      },
      "role": {
        "summary": "لم تُحفظ الصلاحيات",
        "saved": "حُفظت صلاحيات {{name}}.",
        "find": "ابحث عن صلاحية",
        "findPlaceholder": "ابحث في الصلاحيات",
        "selected": "اختير {{selected}} من {{total}}",
        "noMatch": "لا توجد صلاحية تطابق «{{term}}»."
      },
      "editTitle": "تعديل {{name}}",
      "addedNamed": "أُضيف {{name}}.",
      "savedNamed": "حُفظ {{name}}.",
      "problems": {
        "codeFormat": "استخدم حروفاً لاتينية وأرقاماً و- و_ فقط، بحد أقصى 40 حرفاً."
      },
      "node": {
        "summary": "لم تُحفظ وحدة الشراء",
        "sections": {
          "identity": "الهوية",
          "identityHint": "كيف تُسمّى وحدة الشراء هذه وتُرمَّز في منشأتك."
        },
        "code": {
          "placeholder": "RUH-MAIN"
        },
        "costCenter": {
          "placeholder": "CC-1001",
          "hint": "مركز التكلفة في نظامك المالي، للاطلاع."
        }
      },
      "agreement": {
        "summaryCreate": "لم تُضف الاتفاقية",
        "summaryEdit": "لم تُحفظ التغييرات",
        "summaryItem": "لم يُضف البند",
        "summaryReprice": "لم يتغير السعر",
        "added": "أُضيفت الاتفاقية {{reference}} مسودةً.",
        "saved": "حُفظت الاتفاقية {{reference}}.",
        "itemAdded": "أُضيف {{name}} إلى الاتفاقية.",
        "repriced": "سُجّل السعر الجديد لـ {{name}}.",
        "sections": {
          "agreement": "الاتفاقية",
          "agreementHint": "كيف يُشار إليها وتُسمّى.",
          "validity": "مدة السريان",
          "validityHint": "تسري أسعارها من اليوم الأول إلى الأخير، شاملةً كليهما.",
          "terms": "الشروط التجارية",
          "item": "البند",
          "itemHint": "ما يورّده المورّد بموجب هذه الاتفاقية.",
          "price": "السعر والطلب"
        },
        "reference": {
          "placeholder": "FA-2026-014",
          "hint": "مرجعك لهذه الاتفاقية، ولا يتكرر في منشأتك."
        },
        "titleEn": {
          "placeholder": "Catering supplies 2026"
        },
        "titleAr": {
          "placeholder": "توريدات التموين 2026"
        },
        "paymentTerms": {
          "placeholder": "30 يوماً من تاريخ الفاتورة"
        },
        "sku": {
          "placeholder": "SKU-12345",
          "hint": "رمز المورّد نفسه لهذا الصنف."
        },
        "itemNameEn": {
          "placeholder": "Arabica coffee beans, 1 kg"
        },
        "itemNameAr": {
          "placeholder": "حبوب قهوة عربية، 1 كغ"
        },
        "uom": {
          "placeholder": "kg",
          "hint": "الوحدة التي يُسعَّر بها ويُطلب."
        },
        "price": {
          "placeholder": "25.50",
          "hint": "لكل وحدة قياس، قبل الضريبة."
        },
        "moq": {
          "placeholder": "10",
          "hint": "أقل كمية يقبلها المورّد في الطلب الواحد."
        },
        "reason": {
          "placeholder": "المراجعة السنوية للأسعار"
        },
        "problems": {
          "referenceRequired": "أدخل مرجع الاتفاقية.",
          "titleEnRequired": "أدخل الاسم بالإنجليزية.",
          "titleArRequired": "أدخل الاسم بالعربية.",
          "fromRequired": "أدخل أول يوم تسري فيه.",
          "toRequired": "أدخل آخر يوم تسري فيه.",
          "toBeforeFrom": "لا يمكن أن يسبق اليوم الأخير اليوم الأول.",
          "currencyRequired": "اختر عملة الاتفاقية.",
          "nameEnRequired": "أدخل الاسم بالإنجليزية.",
          "nameArRequired": "أدخل الاسم بالعربية.",
          "uomRequired": "أدخل وحدة القياس.",
          "quantityFormat": "أدخل كمية أكبر من صفر بالأرقام، مثل 10 أو 2.5."
        }
      },
      "budget": {
        "summaryCreate": "لم تُضف الميزانية",
        "summaryPeriod": "لم تُضف الفترة",
        "summaryAllocate": "لم يُنقل أي مبلغ",
        "scopeHint": "اتركه فارغاً لتشمل كل وحدات الشراء.",
        "categoryHint": "اتركه فارغاً لتشمل كل الفئات.",
        "currencyHint": "كل مبالغ هذه الميزانية بهذه العملة، ولا يُحوَّل شيء.",
        "notes": {
          "placeholder": "تغطي قائمة خدمة شهر أكتوبر"
        },
        "period": {
          "code": {
            "placeholder": "FY2027-Q1",
            "hint": "رمز قصير كما يظهر في التقارير."
          },
          "nameEn": {
            "placeholder": "First quarter 2027"
          },
          "nameAr": {
            "placeholder": "الربع الأول 2027"
          }
        },
        "reason": {
          "placeholder": "نُقلت إلى المطبخ المركزي الجديد"
        },
        "problems": {
          "periodRequired": "اختر فترة الميزانية.",
          "currencyRequired": "اختر العملة.",
          "codeRequired": "أدخل رمز الفترة.",
          "nameEnRequired": "أدخل الاسم بالإنجليزية.",
          "nameArRequired": "أدخل الاسم بالعربية.",
          "startsRequired": "أدخل اليوم الأول.",
          "endsRequired": "أدخل اليوم الأخير.",
          "reasonRequired": "اذكر سبب تخفيض التخصيص."
        }
      },
      "portalUser": {
        "summary": "لم يُنشأ حساب البوابة",
        "name": {
          "placeholder": "عمر المثال"
        },
        "email": {
          "placeholder": "orders@supplier.example",
          "hint": "عنوان دخوله إلى بوابة المورّدين."
        },
        "phone": {
          "placeholder": "+966 5X XXX XXXX"
        },
        "reason": {
          "placeholder": "ترك العمل لدى المورّد"
        },
        "problems": {
          "nameRequired": "أدخل اسمه.",
          "emailRequired": "أدخل بريده الإلكتروني.",
          "emailFormat": "أدخل بريداً إلكترونياً مثل orders@supplier.example."
        }
      },
      "invoice": {
        "saved": "تم تسجيل فاتورة المورد.",
        "number": {
          "placeholder": "INV-2026-00124"
        },
        "subtotal": {
          "placeholder": "1000.00"
        },
        "tax": {
          "placeholder": "150.00"
        }
      },
      "tax": {
        "rateHint": "نسبة مئوية من 0 إلى 100. تستخدم الرموز المعفاة وذات النسبة الصفرية 0%."
      },
      "date": {
        "today": "اليوم",
        "clear": "مسح",
        "todayFor": "استخدم اليوم في {{label}}",
        "clearFor": "امسح {{label}}",
        "prompt": "اختر تاريخًا"
      },
      "optional": "(اختياري)",
      "fixFields_zero": "يرجى تصحيح الحقول قبل الحفظ.",
      "fixFields_one": "يرجى تصحيح حقل واحد قبل الحفظ.",
      "fixFields_two": "يرجى تصحيح حقلين قبل الحفظ.",
      "fixFields_few": "يرجى تصحيح {{count}} حقول قبل الحفظ.",
      "fixFields_many": "يرجى تصحيح {{count}} حقلًا قبل الحفظ.",
      "fixFields_other": "يرجى تصحيح {{count}} حقل قبل الحفظ.",
      "codeHint": "حروف لاتينية وأرقام و- و_ فقط، ولا يتكرر في منشأتك.",
      "businessReason": {
        "placeholder": "اشرح السبب التجاري لهذا القرار"
      },
      "warehouse": {
        "code": {
          "placeholder": "WH-RUH-01"
        },
        "nameEn": {
          "placeholder": "Riyadh Central Warehouse"
        },
        "nameAr": {
          "placeholder": "مستودع الرياض المركزي"
        },
        "phone": {
          "placeholder": "+966 11 XXX XXXX"
        },
        "email": {
          "placeholder": "warehouse@organisation.example"
        }
      },
      "category": {
        "code": {
          "placeholder": "CAT-PACKAGING"
        },
        "nameEn": {
          "placeholder": "Packaging and disposables"
        },
        "nameAr": {
          "placeholder": "التغليف والمستهلكات"
        }
      },
      "taxCode": {
        "code": {
          "placeholder": "VAT-STD-15"
        },
        "nameEn": {
          "placeholder": "Standard VAT 15%"
        },
        "nameAr": {
          "placeholder": "ضريبة القيمة المضافة القياسية 15%"
        }
      },
      "purchasingUnit": {
        "code": {
          "placeholder": "PU-RUH-PARK"
        },
        "nameEn": {
          "placeholder": "Riyadh Park outlet"
        },
        "nameAr": {
          "placeholder": "منفذ الرياض بارك"
        },
        "deactivateReason": {
          "placeholder": "أُغلق المنفذ بانتهاء عقد إيجاره"
        }
      },
      "receipt": {
        "deliveryNote": {
          "placeholder": "DN-2026-0042"
        },
        "notes": {
          "placeholder": "استُلمت عند رصيف التحميل الخلفي الساعة 09:30"
        },
        "problem": {
          "short": "وصلت 8 كراتين فقط من 10",
          "over": "وصلت 12 كرتونة والمطلوب 10",
          "damaged": "كرتونتان تالفتان أثناء النقل",
          "incorrect": "وصلت عبوات 500 مل بدلاً من 1 لتر",
          "rejected": "تاريخ انتهاء الصلاحية قد مضى"
        },
        "overdue": {
          "placeholder": "وصلت بعد الموعد المحدد بيومين"
        },
        "closeShort": {
          "placeholder": "لم يعد المورّد يورّد هذا الصنف",
          "hint": "3 أحرف على الأقل."
        }
      },
      "quote": {
        "unitPrice": {
          "placeholder": "25.50"
        },
        "taxRate": {
          "placeholder": "15"
        }
      },
      "decision": {
        "partialReason": {
          "placeholder": "خُفِّضت لتطابق الاستهلاك المتوقع لهذا الشهر"
        },
        "returnInstruction": {
          "placeholder": "أرفق عرض سعر المورّد وأكّد الكمية"
        }
      },
      "approvalRule": {
        "code": {
          "placeholder": "RULE-HIGH-VALUE"
        },
        "nameEn": {
          "placeholder": "High-value purchases"
        },
        "nameAr": {
          "placeholder": "المشتريات عالية القيمة"
        },
        "amount": {
          "placeholder": "50000",
          "from": "10000",
          "to": "50000"
        },
        "slaHours": {
          "placeholder": "24"
        }
      },
      "delegation": {
        "endsHint": "يجب أن يكون بعد وقت البدء.",
        "maxAmount": {
          "placeholder": "50000.00",
          "hint": "اختياري. أكبر من صفر، أو اتركه فارغاً بلا حد أعلى."
        },
        "reason": {
          "placeholder": "تغطية خلال الإجازة السنوية"
        }
      },
      "amendment": {
        "reason": {
          "placeholder": "خُفِّضت الكمية لتطابق القائمة المعدّلة",
          "hint": "مطلوب، 3 أحرف على الأقل. يُسجَّل مع الإصدار وفي سجل التدقيق."
        },
        "notes": {
          "placeholder": "التسليم عند رصيف التحميل الخلفي قبل الساعة 10:00"
        }
      },
      "catalogueItem": {
        "code": {
          "placeholder": "RET-ITEM-001"
        },
        "nameEn": {
          "placeholder": "Arabica coffee beans, 1 kg"
        },
        "nameAr": {
          "placeholder": "حبوب قهوة عربية، 1 كغ"
        },
        "uom": {
          "placeholder": "kg"
        },
        "descriptionEn": {
          "placeholder": "Medium roast, whole beans, sealed bag"
        },
        "descriptionAr": {
          "placeholder": "تحميص متوسط، حبوب كاملة، كيس محكم الإغلاق"
        }
      }
    }
  }
}
